import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AddToCartConfirmModel, CartState } from './cart-state-models';

export const cartStateFeatureKey = 'cartState';

export const selectCartStateFeature = createFeatureSelector<CartState>(cartStateFeatureKey);

export const selectAddToCartConfirmModal = createSelector(
  selectCartStateFeature,
  (state: CartState) => (state ? state.modals.addToCartConfirm : null),
);

export const selectQuantityLimitErrorModal = createSelector(
  selectCartStateFeature,
  (state: CartState) => (state ? state.modals.quantityLimitErrorModal.data : null),
);

export const selectAddToCartLoading = createSelector(
  selectAddToCartConfirmModal,
  (state: AddToCartConfirmModel) => (state ? state.loading : null),
);

export const selectCart = createSelector(selectCartStateFeature, (state: CartState) =>
  state ? state.cart : null,
);

export const selectOrderLineById = (id: number) =>
  createSelector(selectCartStateFeature, (state: CartState) =>
    state ? state.cart.orderLines.find((o) => o.orderLineId === id) : null,
  );

export const selectLoading = createSelector(selectCartStateFeature, (state) =>
  state ? state.loading : false,
);

export const selectAddSurpriseBuyLoading = createSelector(selectCartStateFeature, (state) =>
  state ? state.addSurpriseBuyLoading : false,
);
export const selectCartWithLimits = createSelector(selectCartStateFeature, (state: CartState) => {
  if (!state?.cart) return null;

  const limitsMap = state.quantityLimitsMap || {};
  const orderLines = state.cart.orderLines?.map((line) => {
    const limit = limitsMap[line.sku];
    return limit !== undefined ? { ...line, quantityLimit: limit } : line;
  });

  return { ...state.cart, orderLines };
});

export const selectPurchaseLimitRuleModal = createSelector(
  selectCartStateFeature,
  (state: CartState) => (state ? state.modals.purchaseLimitRuleModals.simpleModal : null),
);

export const selectMultiplePurchaseLimitRuleModal = createSelector(
  selectCartStateFeature,
  (state: CartState) => (state ? state.modals.purchaseLimitRuleModals.multipleLineItemModal : null),
);

export const selectOverLimitItems = createSelector(selectCartStateFeature, (state: CartState) =>
  state ? state.modals.purchaseLimitRuleModals.multipleLineItemModal.items : null,
);

export const selectIsCartEmpty = createSelector(selectCartStateFeature, (state: CartState) =>
  state ? state.modals.purchaseLimitRuleModals.isCartEmpty : false,
);
